import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ZPNotification } from "src/app/models/zpnotification";
import { ZpDataService } from "src/app/services/zp-data.service";

@Component({
    selector: "app-chat-box",
    templateUrl: "./chat-box.component.html",
    styleUrls: ["./chat-box.component.scss"],
    standalone: false
})
export class ChatBoxComponent implements OnInit {
  @Input() userId: string;
  @Input() recipientRelations: any;
  @Output() groupedMessagesLengthChange = new EventEmitter<number>();
  @Output() unreadMessagesEvent = new EventEmitter<{
    hasUnreadMessages: boolean;
    totalUnreadMessages: number;
  }>();
  @ViewChild("conversationContainer") conversationContainer: ElementRef;
  public messageToSend: string;
  public groupedMessages: {
    senderId: string;
    senderName: string;
    messages: any[];
    hasUnreadMessages: any;
  }[] = [];
  public selectedUser: {
    senderId: string;
    senderName: string;
    messages: any[];
  } | null = null;
  public retrievedMessages: any;
  // public hasUnreadMessages: boolean = false;
  public selectedUserId: string | null = null;
  public hasEntireConversation: boolean = false;
  relationUserSelected: any;
  myUser: any;
  mySharedPlans: any;
  originalProfessionalsDelegates: any;
  professionalPage: boolean;
  delegatePage: boolean;

  constructor(private api: ZpDataService, private cdr: ChangeDetectorRef) {}

  async ngOnInit(internReload?: boolean) {
    if (!this.myUser) {
      this.myUser = await this.api.getUser();
    }
    console.log('myUser chatBox - ', this.myUser)
    // Retrieve messages from the API and check if there are unread messages
    this.retrievedMessages = await this.api.retrieveMessages();
    console.log("retrieveMessages: ", this.retrievedMessages);
  
    // Group messages and update the groupedMessages array
    this.groupMessagesBySender(this.retrievedMessages);
    console.log("Grouped Messages:", this.groupedMessages);
  
    // Pull out from groupedMessages the senderId if the senderId is the same as the userId
    this.groupedMessages = this.groupedMessages.filter(
      (group) => group.senderId !== this.userId
    );
    console.log("Filtered Grouped Messages (excluding current user):", this.groupedMessages);
  
    // Calculate the length of groupedMessages and emit it to the parent to display the badge
    const length = this.groupedMessages.length;
    this.groupedMessagesLengthChange.emit(length);
  
    // Check if there are unread messages
    this.emitUnreadMessagesStatus();
  
    // Display here the recipient relation
    console.log("recipientRelations: ", this.recipientRelations);
    if (!internReload) {
      // Set the first user in the groupedMessages array as the selected user by default
      if (this.groupedMessages.length > 0) {
        const firstUser = this.groupedMessages[0];
        await this.selectUser(firstUser);
      }
    }
  
    this.originalProfessionalsDelegates = await this.api.getProfessionalsDelegates();
    this.myUser = await this.api.getUser();
    this.mySharedPlans = await this.api.getSharedPlans(this.myUser);
  }
  

  // Add a new method to count unread messages for a given user
  private countUnreadMessages(messages: any[], currentUserId: string): number {
    return messages.filter(
      (message) => message.read === null && message.senderId !== currentUserId
    ).length;
  }

  // Modify the emitUnreadMessagesStatus method to include the count of unread messages
  private emitUnreadMessagesStatus() {
    const hasUnreadMessages = this.groupedMessages.some(
      (group) => group.hasUnreadMessages
    );

    // Count the total number of unread messages
    const totalUnreadMessages = this.groupedMessages.reduce(
      (count, group) =>
        count + this.countUnreadMessages(group.messages, this.userId),
      0
    );

    // Emit both the boolean status and the count of unread messages
    this.unreadMessagesEvent.emit({ hasUnreadMessages, totalUnreadMessages });
  }

  // We send to the API msg and recipientId to send a message
  // Inside the sendMessage method
  async sendMessage(message, recipientId) {
    console.log(message, recipientId);
    let result = await this.api.sendMessage(message, recipientId);
    if (result && result.success) {
      this.messageToSend = "";

      // Create a new message object based on the sent message
      const sentMessage = {
        messageId: result.messageId,
        senderId: this.userId,
        senderName: "You",
        recipientId: recipientId,
        recipientName: this.selectedUser?.senderName || "",
        message: message,
        sent: Date.now(),
        read: null,
      };

      // Update the local state of groupedMessages
      this.updateGroupedMessagesAfterSending(sentMessage, recipientId);

      // // Emit unread messages status
      // this.emitUnreadMessagesStatus();

      this.ngOnInit(true);
      // Scroll to the bottom of the conversation container
      this.scrollToBottom();
    } else {
      alert("Message failed to send. Please try again later.");
    }
  }

  // Add a new method to update groupedMessages after sending a message
  private updateGroupedMessagesAfterSending(
    sentMessage: any,
    recipientId: string
  ) {
    const recipientIndex = this.groupedMessages.findIndex(
      (group) => group.senderId === recipientId
    );

    if (recipientIndex === -1) {
      // If recipient not found, add a new object to the groupedMessages array
      this.groupedMessages.push({
        senderId: recipientId,
        senderName: this.selectedUser?.senderName || "",
        messages: [sentMessage],
        hasUnreadMessages: true, // Sent message is always marques as unread
      });
    } else {
      // If recipient found, push the sent message to the existing array
      this.groupedMessages[recipientIndex].messages.push(sentMessage);

      // Update hasUnreadMessages based on the sent message
      this.groupedMessages[recipientIndex].hasUnreadMessages = true;
    }

    // Update hasEntireConversation based on the condition
    this.hasEntireConversation = this.calculateHasEntireConversation(
      this.groupedMessages[recipientIndex].messages || []
    );
  }

  private groupMessagesBySender(messages: any[]) {
    if (!messages) return;
    this.groupedMessages = [];

    messages.forEach((message) => {
      const { senderId, senderName, read } = message;

      // Check if the sender is the current user
      if (senderId === this.userId) {
        const recipientId = message.recipientId;
        const index = this.groupedMessages.findIndex(
          (group) => group.senderId === recipientId
        );

        if (index === -1) {
          this.groupedMessages.push({
            senderId: recipientId,
            senderName: message.recipientName || "",
            messages: [message],
            hasUnreadMessages: this.hasUnreadMessages(message),
          });
        } else {
          this.groupedMessages[index].messages.push(message);
          this.groupedMessages[index].hasUnreadMessages =
            this.hasUnreadMessages(message);
        }
      } else if (senderId !== this.userId) {
        // Exclude the current user from being included in the list
        const index = this.groupedMessages.findIndex(
          (group) => group.senderId === senderId
        );

        if (index === -1) {
          this.groupedMessages.push({
            senderId,
            senderName,
            messages: [message],
            hasUnreadMessages: this.hasUnreadMessages(message),
          });
        } else {
          this.groupedMessages[index].messages.push(message);
          this.groupedMessages[index].hasUnreadMessages =
            this.hasUnreadMessages(message);
        }
      }
    });
  }

  // Add a function to check if a message has unread status
  private hasUnreadMessages(message: any): boolean {
    // Check if the senderId is different from the currentUser
    if (message.senderId !== this.userId) {
      // If senderId is different, check if read is null or undefined
      return message.read === null || typeof message.read === "undefined";
    }

    // If senderId is the same as currentUser and recipientId is different, consider the message as read
    if (message.recipientId !== this.userId) {
      return false;
    }

    // If senderId and recipientId are the same as currentUser, consider the message as read
    return false;
  }

  async selectUser(
    user: {
      senderId: string;
      senderName: string;
      messages: any[];
    },
    recipientRelations?
  ) {
    this.selectedUserId = user.senderId;

    this.checkRecipientRelation();

    // Retrieve messages where the senderId or recipientId is the selected user's ID
    this.retrievedMessages = await this.api.retrieveMessages();
    const userMessages = this.retrievedMessages.filter(
      (message) =>
        (message.senderId === user.senderId &&
          message.recipientId === this.userId) ||
        (message.senderId === this.userId &&
          message.recipientId === user.senderId)
    );

    // Include messages from both the selected user and the logged-in user
    user.messages = userMessages;
    this.selectedUser = user;

    // Calculate hasEntireConversation immediately after selecting a conversation
    this.hasEntireConversation = this.calculateHasEntireConversation(
      user.messages || []
    );
    console.log("Updated hasEntireConversation:", this.hasEntireConversation);

    // Scroll to the bottom of the conversation container when a user is selected
    this.scrollToBottom();

    // Mark messages as read for the selected user (if the current user is the recipient)
    this.markMessagesAsRead(user.messages);

    this.emitUnreadMessagesStatus();
  }

  // Add a new method to calculate hasEntireConversation
  private calculateHasEntireConversation(messages: any[]): boolean {
    return (
      messages.some((message) => message.senderId === this.userId) &&
      messages.some((message) => message.senderId !== this.userId)
    );
  }

  // We mark the messages as read when the user clicks on a sender to see the messages
  async markMessagesAsRead(messages: any[]) {
    for (const message of messages) {
      if (!message.read && message.senderId !== this.userId) {
        try {
          const result = await this.api.markMessageRead(message.messageId);
          if (result && result.success) {
            // Successfully marked message as read
            console.log(`Message ${message.messageId} marked as read.`);

            // Update the groupedMessages array by marking the message as read
            this.updateGroupedMessages(message.messageId);
          } else {
            // Failed to mark message as read
            console.error(
              `Error marking message ${message.messageId} as read.`
            );
          }
        } catch (error) {
          // Handle any errors during the API call
          console.error(
            `Error marking message ${message.messageId} as read:`,
            error
          );
        }
      }
    }
  }

  // I added this function to update the groupedMessages array after marking a message as read with a flag in case we need to use it in the future
  private updateGroupedMessages(messageId: string) {
    // Iterate through the groupedMessages array and update the 'read' property
    this.groupedMessages.forEach((group) => {
      const foundMessage = group.messages.find(
        (message) => message.messageId === messageId
      );
      if (foundMessage) {
        foundMessage.read = true;
      }
    });
    console.log(
      "Grouped Messages after marking as read: ",
      this.groupedMessages
    );
  }

  // We format the date to be displayed in the chat
  formatDate(timestamp: number): string {
    return timestamp
      ? new Date(timestamp).toLocaleDateString("en-US", {
          day: "numeric",
          month: "short",
        })
      : "No messages";
  }

  // We scroll to the bottom of the conversation container when a user is selected
  private scrollToBottom(): void {
    if (this.conversationContainer) {
      console.log("scrolling to bottom");
      const container = this.conversationContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    }
  }

  async checkRecipientRelation() {
    // Check current route
    const currentRoute = window.location.pathname;

    // Initialize variables
    let foundUser;

    if (currentRoute === "/professional-home-page") {
      // Check if originalProfessionalsDelegates is not available, fetch it
      if (!this.originalProfessionalsDelegates) {
        this.originalProfessionalsDelegates =
          await this.api.getProfessionalsDelegates();
      }
      this.professionalPage = true;

      // Find user in originalProfessionalsDelegates
      foundUser = this.originalProfessionalsDelegates.find(
        (relation) => relation.delegateId === this.selectedUserId
      );
    } else {
      // Check if mySharedPlans is not available, fetch it
      if (!this.mySharedPlans) {
        // Check if myUser is not available, fetch it
        if (!this.myUser) {
          this.myUser = await this.api.getUser();
        }
        this.mySharedPlans = await this.api.getSharedPlans(this.myUser);
      }
      this.delegatePage = true;

      // Find user in mySharedPlans
      foundUser = this.mySharedPlans.find(
        (relation) => relation.clientProfessionalId === this.selectedUserId
      );
    }

    // Log foundUser for debugging
    console.log("foundUser: ", foundUser);

    // If user is found, save it in relationUserSelected variable accessible from HTML
    if (foundUser) {
      this.relationUserSelected = foundUser;
    }
  }

  // Calcul the Date of Birth
  calculateAge(dateOfBirth: string): number | string {
    if (dateOfBirth !== undefined) {
      const isFormatYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth);
      if (isFormatYYYYMMDD) {
        const dobDate = new Date(dateOfBirth);
        if (isNaN(dobDate.getTime())) {
          return "";
        }
        const today = new Date();
        const age = today.getFullYear() - dobDate.getFullYear();
        if (
          today <
          new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate())
        ) {
          return age - 1;
        }
        return age;
      }
      const parts = dateOfBirth.split("/");
      if (parts.length === 3) {
        const formattedDateOfBirth = `${parts[1]}/${parts[0]}/${parts[2]}`;
        const dobDate = new Date(formattedDateOfBirth);

        if (isNaN(dobDate.getTime())) {
          return "";
        }
        const today = new Date();
        const age = today.getFullYear() - dobDate.getFullYear();

        if (
          today <
          new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate())
        ) {
          return age - 1;
        }
        return age;
      }
      return "";
    }
  }
}
